import { defineComponent as _defineComponent } from 'vue'
import { makeValidation } from '../../../form/helpers';
import { BaseFormModel, FormValidation } from '../../../form/interfaces';
import useVuelidate from '@vuelidate/core';
import DynamicForm from '../DynamicForm.vue';
import { PropType, ref, computed, watch } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ValidatedForm',
  props: {
  fm: {
    type: Object as PropType<BaseFormModel>,
    required: true,
  },
},
  emits: {
  'update:validation': (_value: FormValidation) => true,
},
  setup(__props, { expose, emit }) {

const props = __props;





const form = ref<InstanceType<typeof DynamicForm>>();

const rules = computed(() => ({
  fm: makeValidation(props.fm),
}));

const validation = useVuelidate<{ fm: BaseFormModel }>(
  rules,
  computed(() => ({
    fm: props.fm,
  }))
);

watch(
  () => validation.value.fm,
  () => emit('update:validation', validation.value.fm),
  { immediate: true }
);

expose({
  validate() {
    return validation.value.$validate();
  },
  form,
});

return { __sfc: true,props, emit, form, rules, validation, DynamicForm }
}

})